<template>
  <v-container fluid id="project">
    <v-row justify="center" align="center" class="mt-md-16 mt-xs-0">
      <span class="title text-h6 text-sm-h6 text-md-h5 text-lg-h4 text-xl-h4 mb-8">Project</span>
    </v-row>
    <v-row justify="center" align="center">
      <v-col cols="12">
        <div id="project-view">
          <carousel :loop="true" :center="true" :items="3" :margin="0" :autoplay="false" :dots="false" :nav="false"
            :autoplayTimeout="3500" :smartSpeed="450" :responsive="{
              0: { items: 1 },
              768: { items: 2 },
              1170: { items: 3 },
            }" responsiveBaseElement="body">
            <div v-for="(img, index) in images" :key="index">
              <div class="item">
                <div class="shadow-effect">
                  <v-img class="img-circle" :src="img.link" :alt="img.text"></v-img>
                  <div class="desc-style">
                    <p class="text-justify" v-html="img.desc"></p>
                  </div>
                </div>
                <router-link class="project-name" :to="img.to"><span>{{ img.name }}</span>
                </router-link>
              </div>
            </div>
            <div v-for="n in progress" :key="n">
              <div class="item">
                <div class="shadow-effect">
                  <v-row class="project" align="center" justify="center">
                    <span class="text text-sm-h6 text-md-h5 text-xl-h4">Still On Progress</span>
                    <div class="LoaderBallsa">
                      <div class="LoaderBallsitema"></div>
                      <div class="ShadowBallsitema"></div>
                    </div>
                    <div class="LoaderBallsb">
                      <div class="LoaderBallsitemb"></div>
                      <div class="ShadowBallsitemb"></div>
                    </div>
                    <div class="LoaderBallsc">
                      <div class="LoaderBallsitemc"></div>
                      <div class="ShadowBallsitemc"></div>
                    </div>
                  </v-row>
                </div>
                <div class="project-name">Name Project</div>
              </div>
            </div>
          </carousel>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import carousel from "vue-owl-carousel2";
export default {
  name: "HelloWorld",
  components: {
    carousel,
  },
  data() {
    return {
      images: [
        {
          link: require("@/assets/img_project/template_website.png"),
          text: "Website Template",
          desc: "<span class='orange--text text--darken-1 font-weight-medium'>See the website template</span>, <span class='blue--text text--lighten-1 font-weight-medium'>Choose a website template</span>, <span class='light-green--text text--lighten-1 font-weight-medium'>I will turn it into your website</span>",
          name: "See Website",
          to: "Website",
        },
        {
          link: "https://www.omdbapi.com/src/poster.jpg",
          text: "MDb Images",
          desc: "MDb (Movie Database) is an online database of films and television shows including titles, synopses, information about cast and crew, production information, and ratings given by users.",
          name: "MDb",
          to: "Mdb",
        },
        // {
        //   link: "https://placeimg.com/200/200/any?3",
        //   text: "gambar1",
        //   desc: "Dramatically maintain clicks-and-mortar solutions without functional solutions. Completely synergize resource taxing relationships via premier niche markets. Professionally cultivate.",
        //   name: "test3",
        // },
        // {
        //   link: "https://placeimg.com/200/200/any?4",
        //   text: "gambar1",
        //   desc: "Dramatically maintain clicks-and-mortar solutions without functional solutions. Completely synergize resource taxing relationships via premier niche markets. Professionally cultivate.",
        //   name: "test4",
        // },
        // {
        //   link: "https://placeimg.com/200/200/any?5",
        //   text: "gambar1",
        //   desc: "Dramatically maintain clicks-and-mortar solutions without functional solutions. Completely synergize resource taxing relationships via premier niche markets. Professionally cultivate.",
        //   name: "test5",
        // },
      ],
      progress: [2, 3, 4],
    };
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-family: Roboto !important;
  font-size: 600 !important;
  color: var(--var2);
}

.project {
  height: 10vh;
  margin: 100px 0 100px 0;
}

#progress {
  background-color: var(--var2);
  width: 100vw;
  height: 20vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.text {
  font-weight: bold;
  margin-right: 20px;
  font-size: 0.7rem;
  color: var(--var4);
}

.LoaderBallsa {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.LoaderBallsitema {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: var(--var4);
  z-index: 1;
  animation: bounce 1s ease-in-out infinite;
}

.ShadowBallsitema {
  width: 1rem;
  height: 0.1rem;
  border-radius: 50%;
  margin-top: -5px;
  background: rgba(0, 0, 0, 0.2);
  z-index: 0;
  animation: shadow 1s ease-in-out infinite;
}

.LoaderBallsb {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.LoaderBallsitemb {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: var(--var4);
  z-index: 1;
  animation: bounce 1.5s ease-in-out infinite backwards;
}

.ShadowBallsitemb {
  width: 1rem;
  height: 0.1rem;
  border-radius: 50%;
  margin-top: -5px;
  background: rgba(0, 0, 0, 0.2);
  z-index: 0;
  animation: shadow 1.5s ease-in-out infinite;
}

.LoaderBallsc {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.LoaderBallsitemc {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: var(--var4);
  z-index: 1;
  animation: bounce 1s ease-in-out infinite backwards;
}

.ShadowBallsitemc {
  width: 1rem;
  height: 0.1rem;
  border-radius: 50%;
  margin-top: -5px;
  background: rgba(0, 0, 0, 0.2);
  z-index: 0;
  animation: shadow 1s ease-in-out infinite;
}

@keyframes bounce {
  50% {
    transform: translateY(-40px);
  }
}

@keyframes shadow {
  50% {
    width: 0.1rem;
    height: 2px;
    background: rgba(0, 0, 0, 0.05);
  }
}
</style>

<style>
.img-circle {
  /* border-radius: 50%; */
  transform-style: preserve-3d;
  max-width: 100vw;
  margin: 0 auto 17px;
}

.shadow-effect {
  background: var(--var2);
  padding: 20px;
  border-radius: 4px;
  text-align: center;
  border: 1px solid var(--var2);
  box-shadow: 0 19px 38px rgba(0, 0, 0, 0.1), 0 15px 12px rgba(0, 0, 0, 0.02);
}

#project-view .shadow-effect p {
  font-family: inherit;
  font-size: 17px;
  line-height: 1.5;
  margin: 0 0 17px 0;
  font-weight: 300;
}

.project-name {
  margin: -17px auto 0;
  display: table;
  width: auto;
  background: var(--var5);
  padding: 9px 35px;
  border-radius: 12px;
  text-align: center;
  color: #fff;
  box-shadow: 0 9px 18px rgba(0, 0, 0, 0.12), 0 5px 7px rgba(0, 0, 0, 0.05);
}

#project-view .item {
  text-align: center;
  padding: 50px;
  margin-bottom: 80px;
  opacity: 0.2;
  transform: scale3d(0.8, 0.8, 1);
  transition: all 0.3s ease-in-out;
}

#project-view .owl-item.active.center .item {
  opacity: 1;
  transform: scale3d(1, 1, 1);
}

#project-view .owl-dots .owl-dot.active span,
#project-view .owl-dots .owl-dot:hover span {
  background: var(--var5);
  transform: translate3d(0px, -50%, 0px) scale(0.7);
}

#project-view .owl-dots {
  display: inline-block;
  width: 100%;
  text-align: center;
}

#project-view .owl-dots .owl-dot {
  display: inline-block;
}

#project-view .owl-dots .owl-dot span {
  background: var(--var5);
  display: inline-block;
  height: 20px;
  margin: 0 2px 5px;
  transform: translate3d(0px, -50%, 0px) scale(0.3);
  transform-origin: 50% 50% 0;
  transition: all 250ms ease-out 0s;
  width: 20px;
}
</style>
